// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"364":"c6dc85697eeee7e2","404":"035f5ed3782308af","890":"138bee272e698f60","995":"3098f1561cb037cc"}[chunkId] + ".js";
};